import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showSnackbar } from '../../../api/snackbarSlice';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { useState } from 'react';
import { AxiosError } from 'axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export const handleGenerateReport = async (formData) => {
  const { data } = await apiClient.post('/jobs', formData);
  return data;
};

export const useCreateReportsJobHandler = ({ suppressSuccessSnackbar = false, onSuccess: onSuccessCallback } = {}) => {
  const dispatch = useDispatch();
  const { snackbarMessages } = useTranslatedMessages();
  const reportMessages = snackbarMessages.reports ?? {};
  const queryClient = useQueryClient();
  const [loading, setLoading] = useState(false);

  const mutation = useMutation({
    mutationFn: handleGenerateReport,
    onSuccess: () => {
      if (!suppressSuccessSnackbar) {
        dispatch(
          showSnackbar({
            message: reportMessages.report_queue_success,
            severity: 'success',
          }),
        );
      }
      onSuccessCallback?.();
      queryClient.invalidateQueries({ queryKey: ['jobs'] });
    },
    onError: (error) => {
      if (error instanceof AxiosError) {
        dispatch(
          showSnackbar({
            message: error.response?.data?.message || reportMessages.report_generate_error,
            severity: 'error',
          }),
        );
      } else {
        dispatch(
          showSnackbar({
            message: reportMessages.report_unexpected_error,
            severity: 'error',
          }),
        );
      }
    },
    onSettled: () => {
      setLoading(false);
    },
  });

  const onSubmit = async (data) => {
    mutation.mutate(data);
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: mutation.error,
    isPending: mutation.isPending || loading,
    isSuccess: mutation.isSuccess,
    onSubmit,
  };
};
